import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import "../styleSheets/emi.css";
export default function AddEmi({ showAlert }) {
  const [formData, setFormData] = useState({
    friend: "",
    paidBy: "",
    bankName: "",
    emiName: "",
    totalAmount: "",
    emiAmount: "",
    emiType: "",
    totalMonths: "",
    paymentDate: "",
    startMonth: "",
  });
  const [users, setUsers] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [emis, setEmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [editingId, setEditingId] = useState(null);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelEmiId, setCancelEmiId] = useState(null);

  let myId = "";

  if (token) {
    const decoded = jwtDecode(token);

    myId = decoded.user.id;
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/users/friends`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data.friends))
      .catch((err) => console.error(err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updated = {
      ...formData,
      [name]: value,
    };

    if (name === "emiType") {
      if (value === "PERSONAL") {
        updated.friend = "";
        updated.paidBy = myId;
      } else {
        updated.friend = "";
        updated.paidBy = "";
      }
    }

    if (name === "friend") {
      updated.paidBy = "";
    }

    setFormData(updated);
  };

  const validate = (data) => {
    let errors = {};

    if (!data.bankName.trim()) {
      errors.bankName = "Bank Name is required";
    }

    if (!data.emiType) {
      errors.emiType = "EMI Type is required";
    }

    if (!data.emiName.trim()) {
      errors.emiName = "EMI Name is required";
    }

    if (!data.totalAmount) {
      errors.totalAmount = "Total Amount is required";
    }

    if (!data.emiAmount) {
      errors.emiAmount = "EMI Amount is required";
    }

    if (!data.totalMonths) {
      errors.totalMonths = "Total Months is required";
    }

    if (!data.paymentDate) {
      errors.paymentDate = "Payment Date is required";
    }

    if (!data.startMonth) {
      errors.startMonth = "Start Month is required";
    }

    if (Number(data.totalAmount) <= 0) {
      errors.totalAmount = "Enter a valid amount";
    }

    if (Number(data.emiAmount) <= 0) {
      errors.emiAmount = "Enter a valid EMI amount";
    }

    if (Number(data.totalMonths) <= 0) {
      errors.totalMonths = "Enter valid months";
    }

    if (Number(data.emiAmount) > Number(data.totalAmount)) {
      errors.emiAmount = "EMI Amount cannot exceed Total Amount";
    }

    if (Number(data.paymentDate) < 1 || Number(data.paymentDate) > 31) {
      errors.paymentDate = "Payment Date should be between 1 and 31";
    }
    if (data.startMonth) {
      const selected = new Date(data.startMonth);

      const current = new Date();

      current.setDate(1);

      current.setHours(0, 0, 0, 0);

      if (selected < current) {
        errors.startMonth = "Start Month cannot be in the past";
      }
    }

    if (data.emiType === "FRIEND") {
      if (!data.friend) {
        errors.friend = "Please select a Friend";
      }

      if (!data.paidBy) {
        errors.paidBy = "Please select Paid By";
      }
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(formData);

    setErrors(validationErrors);

    setTouched({
      emiType: true,
      bankName: true,
      emiName: true,
      totalAmount: true,
      emiAmount: true,
      totalMonths: true,
      paymentDate: true,
      startMonth: true,
      friend: true,
      paidBy: true,
    });

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    if (submitLoading) return;

    setSubmitLoading(true);

    try {
      const url = editingId
        ? `${process.env.REACT_APP_API_URL}/api/emi/updateEmi/${editingId}`
        : `${process.env.REACT_APP_API_URL}/api/emi/addEmi`;

      const method = editingId ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        showAlert(
          editingId ? "EMI Updated Successfully" : "EMI Added Successfully",
          "success",
        );

        await fetchEmis();

        const modalEl = document.getElementById("emiModal");

        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);

        modal.hide();

        document.body.classList.remove("modal-open");

        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());

        document.body.style.removeProperty("padding-right");

        setFormData({
          friend: "",
          paidBy: "",
          bankName: "",
          emiName: "",
          totalAmount: "",
          emiAmount: "",
          totalMonths: "",
          paymentDate: "",
          startMonth: "",
        });

        setEditingId(null);

        await fetchEmis();
      } else {
        showAlert(result.error || "Unable to add EMI", "danger");
      }
    } catch (err) {
      console.error(err);
      showAlert("Server Error", "danger");
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchEmis = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/emi/ongoing`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const result = await response.json();

      if (result.success) {
        setEmis(result.emis);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmis();
  }, []);

  const handleEdit = (emi) => {
    setEditingId(emi._id);

    setFormData({
      emiType: emi.emiType,

      friend: emi.friend?._id || "",

      paidBy: emi.paidBy?._id || "",

      bankName: emi.bankName,

      emiName: emi.emiName,

      totalAmount: emi.totalAmount,

      emiAmount: emi.emiAmount,

      totalMonths: emi.totalMonths,

      paymentDate: emi.paymentDate,

      startMonth: emi.startMonth?.slice(0, 7),
    });

    // Close Details Modal
    window.bootstrap.Modal.getInstance(
      document.getElementById("emiDetailsModal"),
    )?.hide();

    // Open Add/Edit Modal
    const modal = window.bootstrap.Modal.getOrCreateInstance(
      document.getElementById("emiModal"),
    );

    modal.show();
  };

  const handleCancel = (id) => {
    setCancelEmiId(id);

    const modal = new window.bootstrap.Modal.getOrCreateInstance(
      document.getElementById("cancelEmiModal"),
    );

    modal.show();
  };

  const confirmCancelEmi = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/emi/cancelEmi/${cancelEmiId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const result = await response.json();

      if (result.success) {
        showAlert("EMI Cancelled Successfully", "success");

        await fetchEmis();

        // Close Cancel Modal
        window.bootstrap.Modal.getInstance(
          document.getElementById("cancelEmiModal"),
        )?.hide();

        // Close EMI Details Modal
        window.bootstrap.Modal.getInstance(
          document.getElementById("emiDetailsModal"),
        )?.hide();

        setSelectedEmi(null);
        setCancelEmiId(null);
      } else {
        showAlert(result.error, "danger");
      }
    } catch (error) {
      console.log(error);
      showAlert("Unable to cancel EMI", "danger");
    }
  };

  const handleViewDetails = (emi) => {
    setSelectedEmi(emi);

    // Add history entry for modal
    window.history.pushState({ modal: true }, "");

    setTimeout(() => {
      const modal = window.bootstrap.Modal.getOrCreateInstance(
        document.getElementById("emiDetailsModal"),
      );

      modal.show();
    }, 0);
  };

  const filteredEmis = emis.filter((emi) => {
    const search = searchTerm.toLowerCase();

    const matchesSearch =
      emi.emiName.toLowerCase().includes(search) ||
      emi.bankName.toLowerCase().includes(search) ||
      (emi.friend?.name || "").toLowerCase().includes(search);

    const matchesStatus = statusFilter === "ALL" || emi.status === statusFilter;

    const matchesType = typeFilter === "ALL" || emi.emiType === typeFilter;

    return matchesSearch && matchesStatus && matchesType;
  });

  const endMonth = selectedEmi ? new Date(selectedEmi.startMonth) : null;

  if (endMonth) {
    endMonth.setMonth(endMonth.getMonth() + selectedEmi.totalMonths - 1);
  }

  return (
    <div className="container-fluid mt-4">
      {/* Dashboard */}
      <div className="card shadow-sm border-0 mb-4 filter-card">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-lg-4 col-md-12">
              <input
                type="text"
                className="form-control"
                placeholder="🔍 Search EMI..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="ALL">All Status</option>
                <option value="ONGOING">🟢 Ongoing</option>
                <option value="COMPLETED">✅ Completed</option>
                <option value="CANCELLED">❌ Cancelled</option>
              </select>
            </div>

            <div className="col-lg-4 col-md-6">
              <select
                className="form-select"
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
              >
                <option value="ALL">All Types</option>
                <option value="PERSONAL">💳 Personal</option>
                <option value="FRIEND">👥 Friend</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {/* EMI Details */}
      <div className="card shadow">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">EMI Details</h4>

          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#emiModal"
            onClick={() => {
              setEditingId(null);

              setFormData({
                friend: "",
                paidBy: "",
                bankName: "",
                emiName: "",
                totalAmount: "",
                emiAmount: "",
                totalMonths: "",
                paymentDate: "",
                startMonth: "",
              });
            }}
          >
            + Add EMI
          </button>
        </div>

        <div className="card-body">
          {/* Modal */}

          <div className="modal fade" id="emiModal" tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {editingId ? "Edit EMI" : "Add EMI"}
                    </h5>

                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                    />
                  </div>

                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label className="form-label">EMI Type</label>

                        <select
                          className={`form-select ${
                            touched.emiType && errors.emiType
                              ? "is-invalid"
                              : ""
                          }`}
                          name="emiType"
                          value={formData.emiType}
                          onChange={handleChange}
                        >
                          <option value="select">SELECT TYPE</option>
                          <option value="FRIEND">Friend EMI</option>

                          <option value="PERSONAL">Personal EMI</option>
                        </select>
                        {touched.emiType && errors.emiType && (
                          <div className="invalid-feedback">
                            {errors.emiType}
                          </div>
                        )}
                      </div>

                      {formData.emiType === "FRIEND" && (
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Friend</label>

                          <select
                            className="form-select"
                            name="friend"
                            value={formData.friend}
                            onChange={handleChange}
                          >
                            <option value="">Select Friend</option>

                            {users.map((user) => (
                              <option key={user._id} value={user._id}>
                                {user.name || user.email}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {formData.emiType === "FRIEND" && (
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Paid By</label>

                          <select
                            className="form-select"
                            name="paidBy"
                            value={formData.paidBy}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>

                            <option value={myId}>Me</option>

                            {formData.friend && (
                              <option value={formData.friend}>
                                {
                                  users.find((u) => u._id === formData.friend)
                                    ?.name
                                }
                              </option>
                            )}
                          </select>
                        </div>
                      )}

                      <div className="col-md-6 mb-3">
                        <label>Bank Name</label>

                        <input
                          className={`form-control ${
                            touched.bankName && errors.bankName
                              ? "is-invalid"
                              : ""
                          }`}
                          name="bankName"
                          value={formData.bankName}
                          onChange={handleChange}
                        />
                        {touched.bankName && errors.bankName && (
                          <div className="invalid-feedback">
                            {errors.bankName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>EMI Name</label>

                        <input
                          className={`form-control ${
                            touched.emiName && errors.emiName
                              ? "is-invalid"
                              : ""
                          }`}
                          name="emiName"
                          value={formData.emiName}
                          onChange={handleChange}
                        />
                        {touched.emiName && errors.emiName && (
                          <div className="invalid-feedback">
                            {errors.emiName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>Total Amount</label>

                        <input
                          type="number"
                          className={`form-control ${
                            touched.totalAmount && errors.totalAmount
                              ? "is-invalid"
                              : ""
                          }`}
                          name="totalAmount"
                          value={formData.totalAmount}
                          onChange={handleChange}
                        />
                        {touched.totalAmount && errors.totalAmount && (
                          <div className="invalid-feedback">
                            {errors.totalAmount}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>EMI Amount</label>

                        <input
                          type="number"
                          className={`form-control ${
                            touched.emiAmount && errors.emiAmount
                              ? "is-invalid"
                              : ""
                          }`}
                          name="emiAmount"
                          value={formData.emiAmount}
                          onChange={handleChange}
                        />
                        {touched.emiAmount && errors.emiAmount && (
                          <div className="invalid-feedback">
                            {errors.emiAmount}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>Total Months</label>

                        <input
                          type="number"
                          className={`form-control ${
                            touched.totalMonths && errors.totalMonths
                              ? "is-invalid"
                              : ""
                          }`}
                          name="totalMonths"
                          value={formData.totalMonths}
                          onChange={handleChange}
                        />
                        {touched.totalMonths && errors.totalMonths && (
                          <div className="invalid-feedback">
                            {errors.totalMonths}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>Payment Date</label>

                        <input
                          type="number"
                          min="1"
                          max="31"
                          className={`form-control ${
                            touched.paymentDate && errors.paymentDate
                              ? "is-invalid"
                              : ""
                          }`}
                          name="paymentDate"
                          value={formData.paymentDate}
                          onChange={handleChange}
                        />
                        {touched.paymentDate && errors.paymentDate && (
                          <div className="invalid-feedback">
                            {errors.paymentDate}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>Start Month</label>

                        <input
                          type="month"
                          className={`form-control ${
                            touched.startMonth && errors.startMonth
                              ? "is-invalid"
                              : ""
                          }`}
                          name="startMonth"
                          value={formData.startMonth}
                          onChange={handleChange}
                        />
                        {touched.startMonth && errors.startMonth && (
                          <div className="invalid-feedback">
                            {errors.startMonth}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      type="button"
                    >
                      Cancel
                    </button>

                    <button className="btn btn-primary" type="submit">
                      {editingId ? "Update EMI" : "Save EMI"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
            </div>
          ) : emis.length === 0 ? (
            <div className="text-center py-5">
              <h5>No EMI Found</h5>
            </div>
          ) : (
            <div className="row mt-4">
              {filteredEmis.map((emi) => (
                <div className="col-xl-6 col-lg-6 col-md-12 mb-4" key={emi._id}>
                  <div
                    className={`card shadow-sm border-0 h-100 emi-card ${
                      emi.status === "COMPLETED"
                        ? "completed-card"
                        : emi.status === "CANCELLED"
                          ? "cancelled-card"
                          : emi.emiType === "PERSONAL"
                            ? "personal-card"
                            : "friend-card"
                    }`}
                    onClick={() => handleViewDetails(emi)}
                    style={{ cursor: "pointer", borderRadius: "18px" }}
                  >
                    <div className="card-body">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="fw-bold mb-1">{emi.emiName}</h5>

                          <small className="text-muted">
                            🏦 {emi.bankName}
                          </small>
                        </div>

                        <div>
                          {emi.status === "ONGOING" && (
                            <span className="badge bg-warning text-dark">
                              Ongoing
                            </span>
                          )}

                          {emi.status === "COMPLETED" && (
                            <span className="badge bg-success">Completed</span>
                          )}

                          {emi.status === "CANCELLED" && (
                            <span className="badge bg-danger">Cancelled</span>
                          )}
                        </div>
                      </div>

                      <hr />

                      {/* EMI Amount */}
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Monthly EMI</span>

                        <strong>₹{emi.emiAmount}</strong>
                      </div>

                      {/* Progress */}

                      <div className="progress mb-2" style={{ height: "8px" }}>
                        <div
                          className="progress-bar"
                          style={{
                            width: `${(emi.paidMonths / emi.totalMonths) * 100}%`,
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-between">
                        <small>
                          {emi.paidMonths}/{emi.totalMonths} Months
                        </small>

                        <small>
                          {Math.round((emi.paidMonths / emi.totalMonths) * 100)}
                          %
                        </small>
                      </div>

                      <hr />

                      <div className="row text-center">
                        <div className="col-6">
                          <small className="text-muted d-block">Next Due</small>

                          <strong>
                            {new Date(emi.nextDueDate).toLocaleDateString(
                              "en-GB",
                            )}
                          </strong>
                        </div>

                        <div className="col-6">
                          <small className="text-muted d-block">Type</small>

                          <strong>
                            {emi.emiType === "PERSONAL"
                              ? "💳 Personal"
                              : "👥 Friend"}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* EMI Details Modal */}
      <div className="modal fade" id="emiDetailsModal" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">EMI Details</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div className="modal-body">
              {selectedEmi && (
                <>
                  {/* Header */}

                  <div className="text-center mb-4">
                    <h3 className="fw-bold mb-1">{selectedEmi.emiName}</h3>

                    <div className="text-muted mb-2">
                      🏦 {selectedEmi.bankName}
                    </div>

                    <span
                      className={`badge ${
                        selectedEmi.status === "ONGOING"
                          ? "bg-warning text-dark"
                          : selectedEmi.status === "COMPLETED"
                            ? "bg-success"
                            : "bg-danger"
                      }`}
                    >
                      {selectedEmi.status}
                    </span>
                  </div>

                  {/* Progress */}

                  <div className="mb-4">
                    <div className="d-flex justify-content-between">
                      <strong>Progress</strong>

                      <strong>
                        {selectedEmi.paidMonths}/{selectedEmi.totalMonths}
                      </strong>
                    </div>

                    <div className="progress mt-2">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        style={{
                          width: `${(selectedEmi.paidMonths / selectedEmi.totalMonths) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Quick Summary */}

                  <div className="row g-3 mb-4">
                    <div className="col-6">
                      <div className="detail-box text-center">
                        <small>Monthly EMI</small>

                        <h4>₹{selectedEmi.emiAmount}</h4>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="detail-box text-center">
                        <small>Next Due</small>

                        <h5>
                          {new Date(selectedEmi.nextDueDate).toLocaleDateString(
                            "en-GB",
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}

                  <div className="d-flex flex-wrap gap-2 justify-content-center mb-4">
                    <button
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Go Back
                    </button>

                    {selectedEmi?.paidBy?._id === myId &&
                      selectedEmi.status !== "COMPLETED" && (
                        <button
                          className="btn btn-warning"
                          onClick={() => handleEdit(selectedEmi)}
                        >
                          ✏ Edit
                        </button>
                      )}

                    {selectedEmi?.paidBy?._id === myId &&
                      selectedEmi.status === "ONGOING" && (
                        <button
                          className="btn btn-danger"
                          onClick={() => handleCancel(selectedEmi._id)}
                        >
                          ❌ Stop Emi
                        </button>
                      )}
                  </div>

                  {/* Nav Pills */}

                  <ul
                    className="nav nav-pills nav-fill mb-3"
                    id="emiTabs"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <button
                        className="nav-link active"
                        data-bs-toggle="pill"
                        data-bs-target="#overview"
                      >
                        Overview
                      </button>
                    </li>

                    <li className="nav-item">
                      <button
                        className="nav-link"
                        data-bs-toggle="pill"
                        data-bs-target="#schedule"
                      >
                        Schedule
                      </button>
                    </li>

                    <li className="nav-item">
                      <button
                        className="nav-link"
                        data-bs-toggle="pill"
                        data-bs-target="#more"
                      >
                        More
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    {/* ================= OVERVIEW ================= */}

                    <div className="tab-pane fade show active" id="overview">
                      <div className="row g-3">
                        <div className="col-6">
                          <div className="detail-item text-center">
                            <div className="detail-label">Total Amount</div>

                            <div className="detail-value">
                              ₹{selectedEmi.totalAmount}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item text-center">
                            <div className="detail-label">Paid Amount</div>

                            <div className="detail-value">
                              ₹{selectedEmi.paidAmount}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item text-center">
                            <div className="detail-label">Remaining</div>

                            <div className="detail-value">
                              ₹
                              {selectedEmi.totalAmount - selectedEmi.paidAmount}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item text-center">
                            <div className="detail-label">Months Left</div>

                            <div className="detail-value">
                              {selectedEmi.totalMonths - selectedEmi.paidMonths}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ================= SCHEDULE ================= */}

                    <div className="tab-pane fade" id="schedule">
                      <div className="row g-3">
                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Next Due</div>

                            <div className="detail-value">
                              {new Date(
                                selectedEmi.nextDueDate,
                              ).toLocaleDateString("en-GB")}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Payment Date</div>

                            <div className="detail-value">
                              Every {selectedEmi.paymentDate}
                              <sup>th</sup>
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Started</div>

                            <div className="detail-value">
                              {new Date(
                                selectedEmi.startMonth,
                              ).toLocaleDateString("en-US", {
                                month: "short",
                                year: "numeric",
                              })}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Ends</div>

                            <div className="detail-value">
                              {endMonth
                                ? endMonth.toLocaleDateString("en-US", {
                                    month: "short",
                                    year: "numeric",
                                  })
                                : "-"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ================= MORE ================= */}

                    <div className="tab-pane fade" id="more">
                      <div className="row g-3">
                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">EMI Type</div>

                            <div className="detail-value">
                              {selectedEmi.emiType === "PERSONAL"
                                ? "💳 Personal"
                                : "👥 Friend"}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Friend</div>

                            <div className="detail-value">
                              {selectedEmi.emiType === "PERSONAL"
                                ? "Self"
                                : selectedEmi.friend?.name}
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="detail-item">
                            <div className="detail-label">Paid By</div>

                            <div className="detail-value">
                              {selectedEmi.paidBy?._id === myId
                                ? "Me"
                                : selectedEmi.paidBy?.name}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>{" "}
            {/* modal-body */}
          </div>{" "}
          {/* modal-content */}
        </div>{" "}
        {/* modal-dialog */}
      </div>{" "}
      {/* Cancel Confirmation Modal */}
      <div
        className="modal fade"
        id="cancelEmiModal"
        tabIndex="-1"
        style={{
          display: showCancelModal ? "block" : "none",
          background: "rgba(0,0,0,.5)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-danger">Cancel EMI</h5>
            </div>

            <div className="modal-body text-center">
              <h1>⚠️</h1>

              <h5>Are you sure?</h5>

              <p className="text-muted">
                This EMI will be cancelled.
                <br />
                No future monthly transactions will be generated.
              </p>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowCancelModal(false);
                  setCancelEmiId(null);
                }}
              >
                No
              </button>

              <button className="btn btn-danger" onClick={confirmCancelEmi}>
                Yes, Cancel EMI
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
